function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import useImage from '@restart/hooks/useImage';
import React, { useMemo } from 'react';
import { Group, Image, Layer } from 'react-konva';
import DrawingOverlay from './DrawingOverlay';
import ToolStage from './ToolStage';
import LocalTransform from './utils/LocalTransform';
import { TransformContext } from './utils/useLocalTransform';

function DrawingCanvas({
  width,
  height,
  image: imageOrUrl,
  children,
  ...props
}) {
  const {
    image
  } = useImage(imageOrUrl);
  const localTransform = useMemo(() => new LocalTransform(image || {
    width,
    height
  }, {
    width,
    height
  }), [image, width, height]);
  return React.createElement(ToolStage, _extends({
    width: width,
    height: height
  }, props), React.createElement(Layer, null, React.createElement(Group, {
    scaleX: localTransform.scale,
    scaleY: localTransform.scale,
    x: localTransform.dx,
    y: localTransform.dy
  }, React.createElement(TransformContext.Provider, {
    value: localTransform
  }, image && React.createElement(Image, {
    image: image
  }), React.createElement(DrawingOverlay, null, children)))));
}

export default DrawingCanvas;